export const SELECT_TEAMS_NODES = {
  id: null,
  name: null,
} as const;
